import { useState } from 'react';
import PropTypes from 'prop-types';
import useTranslation from 'next-translate/useTranslation';

// Components
import Icon from '@/components/base/Icon';
import CommentsList from '@/components/composite/Comments/CommentsList';

const RandomCommentsPickerResults = ({
    socialProfile,
    results,
    mutateComments = () => {
        /** */
    }
}) => {
    const { t } = useTranslation('commons');
    const [activeFormReply, setActiveFormReply] = useState(null);

    if (Array.isArray(results) && results?.length) {
        return (
            <div className="mb-3">
                <p className="mb-2 flex items-center gap-2.5 text-icoBlue">
                    <Icon icon="trophy" />
                    <span className="text-sm">
                        {t('commons:random_comments_picker.winning_comments')}
                    </span>
                </p>
                <div className="relative rounded-xl border-2 border-icoBlue bg-icoBlue/10 px-5 py-2">
                    <CommentsList
                        dataComments={[
                            {
                                data: results,
                                summary: { total_count: results.length, unread_count: 0 }
                            }
                        ]}
                        socialProfile={socialProfile}
                        isLoading={false}
                        isLoadingMore={false}
                        isLoadMore={false}
                        markAllAsReadState={{
                            markRepliesAsRead: false,
                            isSubmitting: false,
                            error: null
                        }}
                        setMarkAllAsRead={() => {
                            /** */
                        }}
                        loadMore={() => {
                            /** */
                        }}
                        activeFormReply={activeFormReply}
                        setActiveFormReply={setActiveFormReply}
                        mutateComments={mutateComments}
                        className="pt-3"
                        repliesClassName="ml-5"
                        isWinningComments
                    />
                </div>
            </div>
        );
    }

    return null;
};

RandomCommentsPickerResults.propTypes = {
    socialProfile: PropTypes.object,
    results: PropTypes.array,
    mutateComments: PropTypes.func
};

export default RandomCommentsPickerResults;
